import * as Yup from 'yup';

export const FeedbackSchema = Yup.object().shape({
    feedback: Yup.string().min(1, 'Feedback is required').required('Feedback is required'),
});

export type FeedbackDataType = Yup.InferType<typeof FeedbackSchema>;

type InitialValues = {
    feedback: string;
};

export const FeedbackInitialValues: InitialValues = {
    feedback: '',
};

export interface FeedbackInterface {
    feedback: string;
}
